/**
 * Public API for Marketplace
 * This is the public API for the Marketplace service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface Rarity { 
    /**
     * Unique identifier of the rarity
     */
    id?: string;
    /**
     * Capitalized name of the rarity
     */
    name?: string;
    /**
     * Color as a hex code
     */
    color?: string;
    /**
     * Tier for ordering
     */
    tier?: number;
}

